import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ListStatusModule } from '®shared/list-status';
import { ListStatusDescriptionModule } from '®shared/list-status-description';
import { ListStatusReviewModule } from '®shared/list-status-review';
import { ListSavingStatusModule } from '®shared/reading-list/list-saving-status';

import { ListStatusPanelComponent } from './list-status-panel.component';

@NgModule({
  imports: [
    CommonModule,
    ListStatusModule,
    ListStatusDescriptionModule,
    ListStatusReviewModule,
    ListSavingStatusModule,
  ],
  declarations: [ListStatusPanelComponent],
  exports: [ListStatusPanelComponent],
})
export class ListStatusPanelModule {}
